import { render, staticRenderFns } from "./sheti.vue?vue&type=template&id=5120d4cf&"
import script from "./sheti.vue?vue&type=script&lang=ts&"
export * from "./sheti.vue?vue&type=script&lang=ts&"
import style0 from "./sheti.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports